/* eslint-disable complexity */
import { ISharePluginMobile } from '@src/slide/application/no-edit/plugins/share/base/mobile/share-plugin-m.interface';
import SharePluginBase from '@src/slide/application/no-edit/plugins/share/toc/base/share-plugin-base';
import { AUTH_MOBILE_PLUGIN_CONFIG_NAME } from '@src/slide/application/no-edit/plugins/auth/constants';
import {
    getUrlParameter,
    ScriptLoader, browser, ENV, uaUtil, i18n, isAppVersionGreaterThan,
} from '@src/slide/application/service/edit-extension/edit-extension-export';
import { AuthType, IAuth } from '@src/slide/application/no-edit/plugins/auth/base/auth.interface';
import pngCdnMap from '@tencent/docs-design-resources/mobile/png@2x/cdn.js';
import ua from '@tencent/docs-user-agent';
import { loginType } from '@tencent/docs-multi-tools';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { WechatHelper } from '@src/slide/infrastructure/module/independent/wechat-helper';
import { AuthEventsKeys } from '@src/slide/application/no-edit/plugins/auth/base/auth-events.interface';
import {
    IMobileEditorExtensionService,
} from '@src/slide/application/service/edit-extension/core/editor/mobile/interface';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

declare global {
    interface Window {
        cooperationMobile: any,
        openCooperationMobile: any,
        openAdvPermissionsMobile: any,
        shareToQQInApp: any,
    }
}

export default class SharePluginMobile extends SharePluginBase implements ISharePluginMobile {
    declare protected editExtensionService?: IMobileEditorExtensionService;

    public initPlugin(): void {
        this.editExtensionService?.onReady(() => {
            this.init();
        });
    }

    /**
     * 设置权限按钮
     */
    public setRightButton(): void {
        const getQueryObject = function (search) {
            const theRequest = {};
            let str;
            if (search.startsWith('?')) {
                str = search.substr(1);
            } else {
                str = search;
            }

            const strs = str.split('&');
            for (let i = 0; i < strs.length; i++) {
                theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
            }
            return theRequest;
        };

        const queryObject = getQueryObject(window.location.search) as any;
        const groupCode = getUrlParameter('group_code');  // QQ群号
        const isCreateDoc = getUrlParameter('is_create_doc');  // 是从模板页跳转过来的新建文档
        const enableShare = getCacConfigByKey('titlebar.share', true);
        if (queryObject.preview !== '1' && !(groupCode && isCreateDoc) && enableShare) {
            try {
                window.mqq?.ui.setTitleButtons({
                    right: {
                        iconID: 4,
                        callback() {
                            SlideDataServices.DocInfoManager.promise()
                                .then((docInfoManager) => {
                                    docInfoManager.setDocVisible();
                                });
                            if (window.isCooperationMobileOpen !== undefined
                                && window.isCooperationMobileOpen
                                && window.cooperationMobile !== undefined) {
                                // 调起分享面板前先收起可能存在的权限面板
                                window.cooperationMobile.remove();
                            }
                            window.mqq.ui.showShareMenu();
                        },
                    },
                });
                // eslint-disable-next-line no-empty
            } catch (err) {

            }
        } else if (!enableShare) {
            try {
                window.mqq?.ui.setTitleButtons({
                    right: { hidden: true },
                });
                // eslint-disable-next-line no-empty
            } catch (err) {
            }
        }
    }

    /**
     * 触发分享动作
     */
    public handleShare(config): void {
        if (browser.isMiniProgram) {
            this.navigateToSharePanel();
        } else if (this.hasNativeShare()) {
            const isAutoShare = config?.isAutoShare;
            this.navigateToNativeShare(isAutoShare ? {
                fromConverted4Share: true,
            } : {});
        } else if (ua.isMobileQQBrowser) {
            this.navigateToH5Share();
        }  else if (getCacConfigByKey('custom.mobile.shareMethods.navigateToH5', false)) {
            this.navigateToH5Share();
        }
    }

    public hasNativeShare(): boolean {
        return this.allowSetNativeShareButton()
            || (browser.isPad && isAppVersionGreaterThan('2.1.8'));
    }

    /**
     * @summary 控制原生分享按钮
     * @method allowSetNativeShareButton 是否可设置原生分享按钮
     */
    public allowSetNativeShareButton(): boolean {
        return ua.isTencentDocsAppVersionAboveOrEqual('2.4.0');
    }

    /**
     * @description 调用移动端分享唯一入口
     */
    public showShare(): void {
        window.mqq?.ui?.showShareMenu?.();
    }

    /**
     * 跳转到本地分享页面
     */
    public navigateToNativeShare(opts?): void {
        if (window.mqq) {
            SlideDataServices.DocInfoManager.promise()
                .then((docInfoManager) => {
                    docInfoManager.setDocVisible();
                });
            const shareInfo = opts ? opts : {} as any;
            const {
                isOwner,
                isCreator, domainId, policy, localPadId, rightFlag } = SlideDataServices.DocInfoManager() ?? {};
            shareInfo.share_url = this.getShareLink();
            shareInfo.title = SlideDataServices.SlideTitleManager()?.title;
            shareInfo.source_name = i18n.t('腾讯文档');
            shareInfo.desc = i18n.t('腾讯文档-在线幻灯片');
            shareInfo.image_url = pngCdnMap['file_slide_transparent_150@2x']; // 引入为CDN地址,IOS使用透明底部，安卓使用白色底部
            if (browser.isAndroid) {
                shareInfo.image_url = pngCdnMap['file_slide_150@2x']; // 安卓如果使用透明底部png，会有灰底填充。
            }
            shareInfo.type = 'slide';
            shareInfo.miniprogram_image_url = pngCdnMap['file_slide_500@2x']; // 分享到微信的图，这里后续可对齐其他品类改为canvas画出的带头像和创建人昵称的分享图
            shareInfo.rightFlag = rightFlag;
            shareInfo.policy = isOwner ? this.getPolicy() : policy;
            shareInfo.editable = SlideDataServices.PrivilegeManager()?.editable;
            shareInfo.contentEdited = true;
            shareInfo.isCreator = (isCreator || false);
            // 在群场景中模板url带上群号，返回的url也就会带上群号
            const groupCode = getUrlParameter('group_code');
            if (groupCode) {
                shareInfo.groupCode = groupCode;
            }
            shareInfo.domainId = domainId;
            shareInfo.localPadId = localPadId;
            window.mqq.invoke('docx', 'showSharePage', shareInfo, () => { });
        }
    }

    /**
     * 跳转到h5分享页面
     */
    public navigateToH5Share(): void {
        const { padId = '', domainId = '' } = SlideDataServices.DocInfoManager() ?? {};
        const url = `https://${window.hostname}/scenario/share.html?id=${domainId}$${padId}&from=detail`;
        openUrlForAll({ url });
    }

    protected getAuthPluginName(): string {
        return AUTH_MOBILE_PLUGIN_CONFIG_NAME;
    }

    protected shouldShareForClient(): boolean {
        return browser.isTencentDocApp || browser.isTimQQ || browser.isQQ;
    }

    private init(): void {
        this.setRightButton(); // 必须先于setShareInfo设置setTitleButtons，否则分享按钮不会显示
        // 设置分享信息
        this.setShareInfo();
        // if (SlideApp.docStore.isOwner) {
        // 设置分享面板展示信息
        this.updateShareObjectToClient();
        this.getAuthPlugin()?.onAuthEvent(AuthEventsKeys.AUTH_CHANGE, () => {
            this.setShareInfo();
            this.updateShareObjectToClient();
        });
        this.getAuthPlugin()?.onAuthEvent(AuthEventsKeys.AUTH_EXPIRED, () => {
            this.updateShareObjectToClient();
        });
        this.getAuthPlugin()?.onAuthEvent(AuthEventsKeys.AUTH_EXP_TIME_CHANGE, () => {
            this.updateShareObjectToClient();
        });
        // 提供给QQ native使用的接口
        window.openCooperationMobile = () => {
            const authPlugin = this.getAuthPlugin();
            authPlugin?.show({ isCalledBySharePanel: true, isAdvPremissions: false });
        };
        window.openAdvPermissionsMobile = () => {
            const authPlugin = this.getAuthPlugin();
            authPlugin?.show({ isCalledBySharePanel: true, isAdvPremissions: true });
        };
        // 文档APP分享流程优化
        if (window.mqq && browser.isTencentDocApp && loginType() !== 'wx') {
            // 改版后直接跳转组件
            window.shareToQQInApp = () => {
                const currentUrl: string = window.location.href;
                openUrlForAll({
                    url: `https://docs.qq.com/scenario/docs-component-middleware.html?page-action=open-cooperation&doc-url=${currentUrl}`,
                });
            };
            window.mqq.invoke('ui', 'setOnShareQQFriendHandler', { callback: 'shareToQQInApp' });
        }
    }

    /**
     * @summary 设置分享信息
     * @method setShareInfo 与native交互发送分享信息
     */
    private setShareInfo() {
        // drive内嵌 品类preview场景下/云编/本地编辑场景 无需设置
        if (isPreview() || this.editExtensionService?.isEditableDriveDocs() || ENV.IS_MOBILE_LOCAL_EDIT) return;

        const shareInfo = {} as any;
        const {
            isOwner,
            isCreator, domainId, policy, localPadId, rightFlag } = SlideDataServices.DocInfoManager() ?? {};
        shareInfo.share_url     = this.getShareLink(this.editExtensionService?.isSpecialActivity());
        shareInfo.title         = SlideDataServices.SlideTitleManager()?.title;
        shareInfo.source_name   = i18n.t('腾讯文档');
        shareInfo.desc          = i18n.t('腾讯文档-在线幻灯片');
        shareInfo.image_url = pngCdnMap['file_slide_transparent_150@2x']; // 引入为CDN地址,IOS使用透明底部，安卓使用白色底部
        if (browser.isAndroid) {
            shareInfo.image_url = pngCdnMap['file_slide_150@2x']; // 安卓如果使用透明底部png，会有灰底填充。
        }
        shareInfo.type          = 'slide';
        shareInfo.miniprogram_image_url = pngCdnMap['file_slide_500@2x']; // 分享到微信的图，这里后续可对齐其他品类改为canvas画出的带头像和创建人昵称的分享图
        shareInfo.rightFlag     = rightFlag;
        shareInfo.policy        = isOwner ? this.getPolicy() : policy;
        shareInfo.editable      = SlideDataServices.PrivilegeManager()?.editable;
        shareInfo.contentEdited = true; // TODO
        shareInfo.isCreator     = (isCreator || false);
        // 在群场景中模板url带上群号，返回的url也就会带上群号
        const groupCode = getUrlParameter('group_code');
        if (groupCode) {
            shareInfo.groupCode = groupCode;
        }
        shareInfo.domainId = domainId;
        shareInfo.localPadId = localPadId;
        // 如果在微信中，则加载微信sdk，并回调
        WechatHelper.getInstance().onLoadFinish(() => {
            // 设置微信分享消息的内容
            // setWxShareInfo(shareInfo);
            // 加载完成的时候，可能设置不上，再设置一次
            setTimeout(() => {
                this.setWxShareInfo(shareInfo);
            }, 500);
        });

        // 客户端2.4.0之后的版本调用这个方法时，需要多传一个值控制在移动端app的头部栏不显示分享图标
        if (this.allowSetNativeShareButton()) {
            shareInfo.showShareBtn = false;
        }

        if (window.mqq) {
            window.mqq.invoke('data', 'setShareInfo', shareInfo, () => { });
        }
    }

    /**
     * @summary 设置分享到微信信息
     */
    private setWxShareInfo(shareInfo): void {
        const { title } = shareInfo;
        const { desc } = shareInfo;
        const link = shareInfo.share_url;
        const imgUrl = shareInfo.image_url;

        // 分享给朋友
        window.wx.onMenuShareAppMessage({
            title, // 分享标题
            desc, // 分享描述
            link, // 分享链接，该链接域名必须与当前企业的可信域名一致
            imgUrl, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success() {
            },
            cancel() {
            },
            trigger() {
            },
        });

        // 分享到朋友圈
        window.wx.onMenuShareTimeline({
            title, // 分享标题
            link, // 分享链接，该链接域名必须与当前企业的可信域名一致
            imgUrl, // 分享图标
            success() {
            },
            cancel() {
            },
            trigger() {
            },
        });

        // 分享到QQ
        window.wx.onMenuShareQQ({
            title, // 分享标题
            desc, // 分享描述
            link, // 分享链接
            imgUrl, // 分享图标
            success() {
                // 用户确认分享后执行的回调函数
            },
            cancel() {
                // 用户取消分享后执行的回调函数
            },
        });
    }

    /**
     * 更新分享信息到客户端
     */
    private updateShareObjectToClient() {
        const shareObject = this.initShareObject();
        const auth: IAuth | undefined = this.getAuthPlugin()?.getAuth();
        this.setAuthInfoToShareObject(auth?.info, auth?.isAuthExpired(), shareObject);
        if (window.mqq && this.shouldShareForClient()) {
            window.mqq.invoke('docx', 'setAuthForSharePad', shareObject, () => { });
        }
    }

    /**
     * @description 初始化分享信息
     */
    private initShareObject() {
        const { domainId, localPadId, policy, isCreator, padId } = SlideDataServices.DocInfoManager() ?? {};
        const { title } = SlideDataServices.SlideTitleManager() ?? {};
        const shareObject = {} as any;
        shareObject.authFirstLineInfo   = '';           // 客户端分享面变第一行文案
        shareObject.authSecondLineInfo  = '';           // 客户端分享面变第二行文案
        shareObject.docName     = title;
        shareObject.docType     = 4;                    // 1.doc 2.excel 3.form 4.ppt
        shareObject.taskType    = 1;                     // 1为默认带权限分享面板 （未过期,创造者）
        shareObject.share_url   = this.getShareLink();
        shareObject.domainId = domainId;
        shareObject.localPadId = localPadId;
        shareObject.memLength   = 0;                    // 第二行显示的成员个数
        shareObject.memListPrefix = '';                 // 协作成员显示
        shareObject.descriptionSuffix = '';             // 显示多少成员可编辑
        shareObject.policy      = policy || 2;  // 默认权限任何人可查看
        shareObject.isCreator   = isCreator || false;
        shareObject.padId       = padId;
        return shareObject;
    }

    /**
     * @description 更新分享面板信息
     */
    // eslint-disable-next-line complexity
    private setAuthInfoToShareObject(info, isExpire, shareObject) {
        if (!info || !shareObject) {
            return;
        }
        let showAuthExp = false;
        // eslint-disable-next-line no-constant-condition
        if (true) {
            // 770及以上版本才去更新共享信息
            if (uaUtil.MQQLargerOrEqual('7.7.0')) {
                showAuthExp = SlideDataServices.DocInfoManager()?.isOwner && isExpire;
            } else {
                showAuthExp = false;
            }
        }
        /* eslint-disable  no-param-reassign */
        if (showAuthExp) {
            shareObject.taskType = 2;
            shareObject.authFirstLineInfo = i18n.t('文档访问链接已失效');
            shareObject.authSecondLineInfo = i18n.t('他人将无法访问该文档。');
            shareObject.memLength = 0;
            shareObject.memListPrefix = '';
            shareObject.descriptionSuffix = '';
        } else {
            shareObject.taskType = 1;
            shareObject.policy = info.policy; // 当前文档权限
            shareObject.authFirstLineInfo = this.getAuthTips(info.policy);
            // 权限为仅自己可查看/编辑 && 获得链接的人可编辑，文档过期，不显示memlist
            if (info.memlist && info.memlist.length > 0 && info.policy !== 0 && info.policy !== 3) {
                const editMembers = info.memlist.filter(mem => mem.info === 2);
                shareObject.memLength = editMembers.length;
                if (editMembers.length !== 0) {
                    shareObject.memListPrefix = this.getMemberTips(editMembers);
                    shareObject.descriptionSuffix = i18n.t('其中{0}位成员可编辑:', { 0: editMembers.length });
                } else {
                    shareObject.memListPrefix = '';
                    shareObject.descriptionSuffix = '';
                }
            } else {
                shareObject.memLength = 0;
                shareObject.memListPrefix = '';
                shareObject.descriptionSuffix = '';
            }
        }
        /* eslint-enable  no-param-reassign */
    }

    /**
     * @description 根据权限类型获取权限信息提示
     */
    private getAuthTips(policy) {
        let authTips = i18n.t('获得链接的任何人可查看文档');
        switch (policy) {
            case 0:
                authTips = i18n.t('仅自己可查看/编辑文档');
                break;
            case 1:
                authTips = i18n.t('仅指定的人可查看/编辑文档');
                break;
            case 2:
                authTips = i18n.t('获得链接的任何人可查看文档');
                break;
            case 3:
                authTips = i18n.t('获得链接的任何人可编辑文档');
                break;
        }
        return authTips;
    }

    /**
     * @description 显示可以编辑的成员
     */
    private getMemberTips(members) {
        let memberTip = '';
        if (members.length > 0) {
            for (let i = 0; i < Math.min(members.length, 10); i++) {
                if (memberTip === '' && i === 0) {
                    memberTip = members[i].nick;
                    continue;
                }
                memberTip += `、${members[i].nick}`;
            }
        }
        return memberTip;
    }

    /**
     * 获取当前权限信息
     */
    private getPolicy(): AuthType {
        return this.getAuthPlugin()?.getAuth().policy || SlideDataServices.DocInfoManager()?.policy || 0;
    }
}
